export default "__VITE_ASSET__ec150898__"